module.exports = __webpack_public_path__ + "img/a83f6f8.svg";